import type { PageProps } from 'gatsby';
import React from 'react';

import { FeatureGuard } from '@components/Guards';

import ImportJobForm from '@views/Admin/NewAccount/ImportJobForm';

export default function ImportUsersPage({ params }: PageProps) {
  return (
    <FeatureGuard feature="UserInitiateBulkImport">
      <ImportJobForm {...params} />
    </FeatureGuard>
  );
}
